import { render, staticRenderFns } from "./StatisticsChartCard.vue?vue&type=template&id=3ef2129e"
import script from "./StatisticsChartCard.vue?vue&type=script&lang=js"
export * from "./StatisticsChartCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports